/**
 * Convert a hex color string to an rgba() CSS value.
 *
 * Accepts 6-digit hex with leading '#' (e.g. "#2E90FA").
 * Returns `rgba(r, g, b, alpha)` for use in inline styles.
 */
export function hexToRgba(hex: string, alpha: number): string {
  const r = parseInt(hex.slice(1, 3), 16);
  const g = parseInt(hex.slice(3, 5), 16);
  const b = parseInt(hex.slice(5, 7), 16);
  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
}
